import CommentBox1 from "@/components/video/videoComments/commentBox1"
import CommentHolder from "@/components/video/videoComments/commentHolder"
import { typesOfComments } from "@/components/video/videoComments/main/constants"
import { maxScreenWidthForDesktop } from "@/pages/watch/main/constants"
import { useLocalTranslation } from "@/hooks/useLocalTranslation"
import WhitePlus from "@/assets/icons/whitePlus.png";

import "./style.css"
import { useAuthToken } from "@/hooks/useAppSelectors"
import { addCurrentThemeClassToEle } from "@/utils"
import { useSelector } from "react-redux"
import { RootState } from "@/store"
export default function DesktopCommentsView(props: any) {
    const token = useAuthToken()
    const { common } = useLocalTranslation()
    const currentTheme = useSelector((state: RootState) => state.currentThemeReducer.currentTheme);

    return (
        <div className={`desktopCommentsView ${addCurrentThemeClassToEle(currentTheme, 'desktopCommentsView')}`}>

            {/* {props.screenWidth > maxScreenWidthForDesktop && */}
            {props.allComments.length > 0 &&
                <h1 className='text-[16px] font-bold mb-[13px]'>
                    {common.statusText.comments}
                </h1>
            }
            {/* } */}

            {props.allComments.length === 0 ? (
                <div className="singleCommentCon">
                    {props.showCommentBox1WhenAddCommentBtnIsClick ? (
                        <CommentBox1
                            username={props.profileDetails.username}
                            typeOfComment={typesOfComments.firstComment}
                            autoFocusOnMount={props.showCommentBox1WhenAddCommentBtnIsClick}
                            handleBlurFromParent={props.handleBlur}
                        />
                    ) : (
                        <div className="zeroCommentCon">
                            <h1 className='text-[16px] font-bold'>
                                {common.statusText.comments}
                            </h1>

                            <div
                                ref={props.zeroCommentConRef}
                                className="zeroCommentCon01">
                                <p className="p1">
                                    {common.statusText.noCommentYet}
                                </p>
                                {token &&
                                    <button
                                        onClick={props.handleAddCommentBtn}
                                        className="addCommentBtn">
                                        <img
                                            className="w-[10px]"
                                            src={WhitePlus}
                                            alt="WhitePlus" />
                                        {common.statusText.addComment}
                                    </button>
                                }
                            </div>
                        </div>
                    )}
                </div>
            ) : (
                <div className="nonZeroCommentCon1">
                    <div className="singleCommentCon">
                        <CommentBox1
                            username={props.profileDetails.username}
                            typeOfComment={typesOfComments.notFirstComment}
                        />
                    </div>
                    {props.allComments?.map((comment: any, index: number) =>
                        props.showComment(comment) ? (
                            <div key={index}>
                                <CommentHolder
                                    commentDetails={comment}
                                    typesOfCommentFromParent={typesOfComments.replyToComment}
                                />
                            </div>
                        ) : null
                    )}

                </div>
            )}
        </div>
    );
}


